import angular from "angular";

angular
    .module('app')
    .component('commentsControl', {
        template: require('./comments-control.html'),
        controller: ['$uibModal', 'Notifier', '$http', controller],
        bindings: {
            courses: '<',
        }
    });

function controller($uibModal, Notifier, $http) {

    let $ctrl = this;

    $ctrl.page = 1;
    $ctrl.perPage = 10;

    $ctrl.id;
    $ctrl.course = null;
    $ctrl.lesson = null;
    $ctrl.user = null;

    $ctrl.$onInit = function () {
        $ctrl.getList();
    };

    $ctrl.getList = function () {
        $http
            .get('/admin/comments/get-list', {
                params: {
                    page: $ctrl.page,
                    per_page: $ctrl.perPage,
                    id: $ctrl.id,
                    course_id: $ctrl.course ? $ctrl.course.id : null,
                    lesson_id: $ctrl.lesson ? $ctrl.lesson.id : null,
                    user_id: $ctrl.user ? $ctrl.user.id : null,
                }
            })
            .then(
                function (response) {
                    $ctrl.comments = response.data.data;
                    $ctrl.total = response.data.total;
                },
                function (error) {
                }
            );
    };

    $ctrl.courseChanged = function () {
        $ctrl.lesson = null;
    };

    $ctrl.userSelected = function (user) {
        $ctrl.user = user;
    };

    $ctrl.resetFilter = function () {
        $ctrl.page = 1;
        $ctrl.id = null;
        $ctrl.user = null;
        $ctrl.course = null;
        $ctrl.lesson = null;
        $ctrl.getList();
    };

    $ctrl.doFilter = function () {
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.openComment = function (comment) {
        $uibModal.open({
            component: 'commentDetail',
            resolve: {
                comment: function () {
                    return comment;
                }
            }
        });
    };

    $ctrl.replyForComment = function (comment) {
        $uibModal
            .open({
                component: 'commentReplyForm',
                resolve: {
                    comment: function () {
                        return comment;
                    }
                }
            });
    };

    $ctrl.delComment = function (comment, ind) {

        if (comment.deleteLoading) {
            return;
        }

        if (!confirm('Вы действительно хотите удалть данный комментарий?')) {
            return;
        }

        comment.deleteLoading = true;

        $http
            .delete(`/admin/comments/${comment.id}`)
            .then(
                function (response) {
                    if (response.data.has_child_comments) {
                        comment.is_deleted = true;
                    } else {
                        $ctrl.comments.splice(ind, 1);
                    }
                    comment.deleteLoading = false;
                    Notifier.success('Комментарий успешно удален', 2);
                },
                function (error) {
                    Notifier.error(error.data.message, 2);
                    comment.deleteLoading = false;
                }
            );
    };

    $ctrl.checked = function (comment) {
        $http
            .post(`/admin/comments/${comment.id}/checked`)
            .then(
                function (response) {
                    comment.is_checked = true;
                },
                function (error) {
                }
            );
    };

    $ctrl.findParentComment = function (id) {
        $ctrl.page = 1;

        $ctrl.id = id;
        $ctrl.user = null;
        $ctrl.course = null;
        $ctrl.lesson = null;

        $ctrl.getList();
    };
}
